import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Cached server config (auth_base, mode, features)
let _config = null;
let _configPromise = null;
export async function getServerConfig() {
  if (_config) return _config;
  if (!_configPromise) {
    _configPromise = api.get("/config")
      .then(r => { _config = r.data; return _config; })
      .catch((e) => { _configPromise = null; throw e; });
  }
  return _configPromise;
}
export function clearServerConfigCache() { _config = null; _configPromise = null; }

// Auto-refresh on 401 once
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url?.includes("/auth/")) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
        }
        await refreshing;
        return api(original);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
